import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface EyebrowProps {
  index: string;
  label: string;
  className?: string;
}

/** Mono "01 —— Label" kicker shown above each section heading. */
export const Eyebrow = ({ index, label, className }: EyebrowProps) => (
  <div
    className={cn(
      "flex items-center gap-3 font-mono text-[13px] uppercase tracking-[0.08em] text-accent-text",
      className,
    )}
  >
    <span>{index}</span>
    <span className="h-px w-7 bg-current" aria-hidden="true" />
    <span>{label}</span>
  </div>
);

interface SectionHeadingProps extends EyebrowProps {
  children: ReactNode;
}

const SectionHeading = ({ index, label, className, children }: SectionHeadingProps) => (
  <>
    <Eyebrow index={index} label={label} className={className} />
    <h2 className="mt-[18px] text-[clamp(32px,4.4vw,56px)] font-semibold leading-[1.05] tracking-[-0.035em]">
      {children}
    </h2>
  </>
);

export default SectionHeading;
